
import { supabase } from "@/lib/supabase";
import { DBMessage, MessageSenderType, MessageTone, MessageMetadata } from "@/types/message";
import { convertToDBMessage } from "./types";

export async function addMessage(
  refundRequestId: string,
  senderType: MessageSenderType,
  content: string,
  tone?: MessageTone,
  metadata?: MessageMetadata,
  relatedToMessageId?: string,
  version?: number
): Promise<DBMessage> {
  let metadataJson = metadata ? { ...metadata } : {};
  
  const { data, error } = await supabase
    .from("messages")
    .insert({
      refund_request_id: refundRequestId,
      sender_type: senderType,
      content,
      tone: tone || null,
      is_regenerated: relatedToMessageId ? true : false,
      metadata: metadataJson,
      related_to_message_id: relatedToMessageId || null,
      version: version || 1
    })
    .select()
    .single();
  
  if (error) throw error;
  
  return convertToDBMessage(data);
}
